import Alpine from "alpinejs";

import breakpointIs from "../../modules/breakpointIs";

Alpine.magic("breakpointIs", () => (key) => {
    return breakpointIs(key);
});